import { LinkIcon } from "@heroicons/react/24/solid";

export const Link = ({ href, title }: { href: string; title?: string }) => {
    return (
        <a
            href={href}
            role="button"
            className="link-memo my-1"
            target="_blank"
            rel="noreferrer"
        >
            <span className="inline-flex items-center gap-2">
                {title && <span className="body-s">{title}</span>}
                <LinkIcon className="size-4" />
            </span>
        </a>
    );
};
